module.exports = __webpack_public_path__ + "static/media/insta.a1f53cb2.svg";